export const environment = {
  production: false,
  apiUrl: 'https://devapi.cahcc.com/',
  // apiUrl: 'https://localhost:44360/',
  // apiUrl: 'https://localhost:7016/',
  url: 'https://dev.cahcc.com/',
  bearerToken: 'cahcc-token',
};